export const listaODS = [
    { 
    id:1, 
    label: "ODS1: Erradicação da Pobreza"
    },
    {
    id: 2, 
     label: "ODS2: Fome Zero"
    },
    { 
    id:3, 
    label: "ODS3: Boa Saúde e Bem-Estar"
    },
    {
    id: 4, 
    label: "ODS4: Educação de Qualidade"
    },
    { 
    id:5,
    label: "ODS5: Igualdade de Gênero"
    },
    {
    id: 6, 
    label: "ODS6: Água potável e saneamento"
    }, { 
    id:7, 
    label: "ODS7: Energia acessível e limpa"
    },
    {
    id: 8, 
    label: "ODS8: Trabalho Digno e Crescimento Econômico"
    },
    {
    id: 9, 
    label: "ODS9: Indústria, Inovação e Infraestrutura"
    },
    {
    id: 10,
    label: "ODS10: A redução das desigualdades"
    },
    {
    id: 11, 
    label: "ODS11: Cidades e Comunidades Sustentáveis"
    },
    {
    id: 12, 
    label: "ODS12: Consumo e Produção responsáveis"
    },
    {
    id: 13, 
    label: "ODS13: Ação contra mudança global do clima"
    },
    {
    id: 14, 
    label: "ODS14: Vida na água"
    },
    {
    id: 15, 
    label: "ODS15: Vida Terrestre"
    },
    {
    id: 16, 
    label: "ODS16: Paz, Justiça e instituições eficazes"
    },
    {
    id: 17, 
    label: "ODS17: Parcerias e meios de implementação"
    },
]

export const opcaoTematica=[
    {
    id:1,
    label:'Sim, em todas as localidades'    
    },
    {
    id:2,
    label:'Sim, em parte das localidades'    
    },
    {
    id:3,
    label:'Não há priorização definida'    
    }
    ]

export const tagsRel ={
    headers:[
        { key: "cnpj", label: "CNPJ"},
        { key: "empresa", label: "Empresa"},
        { key: "ano", label: "Ano"},
        { key: "possuiMapeamento", label: "Empresa possui um mapeamento de fóruns/conselhos de desenvolvimento local com representatividade(governo local, comunidade, instituições da sociedade civil, empresas) nos territórios onde atua"},
        { key: "fazParteEstrategia", label: "A participação nos fóruns/conselhos de desenvolvimento local faz parte da estratégia"},
        { key: "priorizamTematica", label: "Os fóruns/conselhos priorizam temáticas para discussão sobre o desenvolvimento local?"},
        { key: "saude", label: "Saúde"},
        { key: "educacao", label: "Educação"},
        { key: "infraestruturaUrbana", label: "Infraestrutura Urbana"},
        { key: "saneamentoBasico", label: "Saneamento Básico"},
        { key: "segurancaPublica", label: "Segurança PÚblica"},
        { key: "direitosHumanos", label: "Direitos Humanos"},
        { key: "meioAmbiente", label: "Meio Ambiente"},
        { key: "diversidadeInclusao", label: "Diversidade e Inclusão"},
        { key: "geracaoDeRenda", label: "Geração de Renda"},
        { key: "diversificacaoEconomica", label: "Diversificação Econômica"},
        { key: "outro", label: "Outro"},
        //Mao de obra
        { key: "incentivaContratacaoLocal", label: "Empresa incentiva e prioriza a contratação de mão de obra local de terceiros"},
        { key: "metasFormais", label: "Empresa tem metas formais para contratação de mão de obra local própria"},
        { key: "contratadosLocalmente", label: "Quantos são contratados localmente"},
        { key: "locaisProprios", label: "Destes locais, quantos são próprios"},
        { key: "locaisTerceiros", label: "Destes locais, quantos são terceiros"},
        { key: "metaCotratacaoEmpresa", label: "Meta de priorização e contratação de mão de obra local própria adotada pela empresa (%)"},
        { key: "prazoMetaCotratacao", label: "Prazo para cumprir esta meta"},
        //ODS
        { key: "empresaAdota", label: "Empresa adota os Objetivos de Desenvolvimento Sustentável (ODSs) da ONU orientando suas políticas e ações sociais"},
        { key: "empresaIncentiva", label: "Empresa incentiva à adoção das ODS pelos agentes locais (governo local, comunidade, instituições da sociedade civil, empresas) nos territórios onde atua"},
        { key: "acoesImplementadas", label: "Ações implementadas"},
        { key: "ordemOds", label: "Quais ODSs a empresa priorizou?"},
        //Formação e dev
        { key: "formacaoLiderancaInterno", label: "Empresa possui programas de formação de lideranças da mineração (Público interno) nos territórios com foco na agenda de desenvolvimento local e regional"},
        { key: "metaFormacaoInterno", label: "Meta de formação liderança (Público interno)(%)"},
        { key: "tematicasInterno", label: "Principais temáticas abordadas no programa de formação"},
        { key: "formacaoPublicoExterno", label: "Empresa incentiva/desenvolve junto aos municípios um programa de formação do público externo nos territórios com foco na agenda de desenvolvimento local e regional"},
        { key: "metaFormacaoExterno", label: "Meta de formação liderança (Público externo)(%)"},
        { key:"tematicasExterno", label:"Principais temáticas abordadas no programa de formação(Público externo)"},
        { key: "observacao", label: "Observações"},
        { key: "createdAt", label: "Data de Criação"},
        { key: "updatedAt", label: "Data de Atualização"},
    ]
}
export const tagsRelForuns ={
    headers:[
        { key: "cnpj", label: "CNPJ"},
        { key: "empresa", label: "Empresa"},
        { key: "ano", label: "Ano"},
        { key: "nomeForum", label: "Nome do Fórum/Conselho"},
        { key: "participaAtivamente", label: "Empresa participa ativamente"},
        { key: "createdAt", label: "Inserido"},
        { key: "updatedAt", label: "Atualizado"},
    ]
}